import { UserManager } from "oidc-client";

// Example: 
// authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_oFtz96ERR",
// client_id: "3qqb7km5qei2sq435rb0km4hjv",
// redirect_uri: https://admin.mr-sandbox.net,
// response_type: "code",
// scope: "email openid phone"
const cognitoAuthConfig = {
    authority: process.env.VUE_APP_COGNITO_AUTHORITY,
    client_id: process.env.VUE_APP_COGNITO_CLIENT_ID,
    redirect_uri: process.env.VUE_APP_ADMIN_AUTH_CALLBACK_URI,
    response_type: "code",
    scope: "email openid phone"
};

if (!process.env.VUE_APP_ADMIN_AUTH_CALLBACK_URI) {
    throw new Error('cognitoAuth -- VUE_APP_ADMIN_AUTH_CALLBACK_URI is not defined');
}

// create a UserManager instance
export const userManager = new UserManager({
    ...cognitoAuthConfig,
});

export async function signOutRedirect () {
    const clientId = process.env.VUE_APP_COGNITO_CLIENT_ID;
    const logoutUri = "<logout uri>";
    const cognitoDomain = process.env.VUE_APP_COGNITO_DOMAIN;
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}